import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/landing/Navbar";
import { Hero } from "./components/landing/Hero";
import { Marquee } from "./components/landing/Marquee";
import { Problem } from "./components/landing/Problem";
import { PackageSection } from "./components/landing/Package";
import { WhyLaser } from "./components/landing/WhyLaser";
import { CostComparison } from "./components/landing/CostComparison";
import { DoctorCare } from "./components/landing/DoctorCare";
import { Comfort } from "./components/landing/Comfort";
import { RealResults } from "./components/landing/RealResults";
import { EMI } from "./components/landing/EMI";
import { HowItWorks } from "./components/landing/HowItWorks";
import { WhoIsThisFor } from "./components/landing/WhoIsThisFor";
import { FAQ } from "./components/landing/FAQ";
import { Trust } from "./components/landing/Trust";
import { FinalCTA, Footer } from "./components/landing/FinalCTA";
import { StickyBar } from "./components/landing/StickyBar";
import { LeadModal } from "./components/landing/LeadModal";

function App() {
  const [leadOpen, setLeadOpen] = useState(false);
  const openLead = () => setLeadOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ivory text-ink font-sans overflow-x-clip">
      <div className="grain" aria-hidden="true" />
      <Navbar onBook={openLead} />
      <main className="pb-20 md:pb-0">
        <Hero onBook={openLead} />
        <Marquee />
        <Problem />
        <PackageSection onBook={openLead} />
        <WhyLaser />
        <CostComparison />
        <DoctorCare />
        <Comfort />
        <RealResults />
        <EMI />
        <HowItWorks />
        <WhoIsThisFor />
        <FAQ />
        <Trust />
        <FinalCTA onBook={openLead} />
        <Footer />
      </main>
      <StickyBar />
      <LeadModal open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}

export default App;
